<li ngbDropdown class="nav-item dropdown-notification mr-25" #dropdown="ngbDropdown" [autoClose]="false"
    *ngIf="showBar">
    <a class="nav-link" ngbDropdownToggle id="secondNabarDropdown"
        [ngbTooltip]="selectedStation ? selectedThings: undefined"><i class="ficon" data-feather="layers"></i></a>
    <ng-container *ngIf="!inputsLoading">
        <ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown"
            class="dropdown-menu dropdown-menu-media dropdown-menu-right">
            <li class="scrollable-container py-2">
                <div class="row justify-content-end align-items-center m-0">
                    <!-- <div class="col-12" *renderIf="{roles: ['employee'], module: 'company', right: ''}">
                        <div class="form-group">
                            <ng-select placeholder="Select Company" [items]="companies" [clearable]="true"
                                bindLabel="name" [(ngModel)]="selectedCompany" (change)="handleCompanyChange($event)"
                                [virtualScroll]="true">
                                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                    <span class="ng-value-label d-flex align-items-center">{{item.name}}</span>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    <div class="d-flex align-items-center" [ngbTooltip]="item.name"
                                        [placement]="index == 0? 'bottom': 'top'">
                                        {{item.name}}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div> -->
                    <div class="col-12">
                        <div class="form-group mb-0">
                            <ng-select placeholder="Select Station" [items]="stations" [clearable]="true"
                                bindLabel="name" [(ngModel)]="currentSelectedStation" [virtualScroll]="true">
                                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                    <span class="ng-value-label d-flex align-items-center">{{item.name}}</span>
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <div class="d-flex align-items-center" [ngbTooltip]="item.name" placement="left">
                                        {{item.name}}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </li>
            <li class="dropdown-menu-footer">
                <div class="row">
                    <div class="col-md-6 order-md-1 mb-md-0 mb-50">
                        <button class="btn btn-primary btn-block" (click)="applyFilter()" [disabled]="applying">
                            <span class="spinner spinner-border spinner-border-sm" *ngIf="applying"></span>
                            Apply Filter
                        </button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-outline-secondary btn-block" (click)="dropdown.close()"
                            [disabled]="applying">Cancel</button>
                    </div>
                </div>
            </li>
        </ul>
    </ng-container>
</li>

<ng-template #selectedThings>
    <span style="width: 200px;" *ngIf="selectedCompany && selectedStation">
        <span *ngIf="selectedCompany">
            {{selectedCompany.name}}
        </span>
        <ng-container *ngIf="selectedStation">
            <br>
            <br>
            <span>
                {{selectedStation.name}}
            </span>
        </ng-container>

    </span>
</ng-template>